import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";

const ResetPassword = () => {
  const [params] = useSearchParams();
  const token = params.get("token");

  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleReset = async () => {
    if (!password) {
      alert("Введите пароль");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(
        `/api/auth/reset-password?token=${token}&newPassword=${encodeURIComponent(password)}`,
        { method: "POST" }
      );

      if (res.ok) {
        alert("Пароль изменен");
        window.location.href = "/login";
      } else {
        alert("Ошибка или токен устарел");
      }
    } catch {
      alert("Ошибка сети");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={container}>
      <div style={card}>
        <h2>Сброс пароля</h2>

        <input
          type="password"
          placeholder="Новый пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={input}
        />

        <button onClick={handleReset} style={btn}>
          {loading ? "Сохранение..." : "Сохранить пароль"}
        </button>
      </div>
    </div>
  );
};

const container = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "100vh",
};

const card = {
  background: "rgba(17,17,17,0.8)",
  padding: "30px",
  borderRadius: "12px",
  width: "100%",
  maxWidth: "400px",
  color: "#fff",
  textAlign: "center",
};

const input = {
  width: "94%",
  padding: "10px",
  marginTop: "15px",
  borderRadius: "8px",
};

const btn = {
  marginTop: "15px",
  padding: "10px",
  width: "100%",
  background: "linear-gradient(90deg, #00c6ff, #0072ff)",
  border: "none",
  borderRadius: "8px",
  fontWeight: "bold",
};

export default ResetPassword;